export default "__VITE_ASSET__Dfxyma$F__"